export default __webpack_public_path__ + "static/media/alertContractDebt.9fcbb939.svg";